import { useQuery } from "@tanstack/react-query";
import { getLevelNImagePathWithAPIKey } from "../../../../../services/b2b-frameworks-apiService";
import { fullImagePath } from "../../../../b2b-common/helpers";

const useSDGsImages = (locale = 'es') => {

    const getImagePath = async (sdgId, locale) => {
        try {
            const imagePath = await getLevelNImagePathWithAPIKey('generic', 2, sdgId, locale);
            return fullImagePath(imagePath);
        } catch (error) {
            console.error('Error getting image path for SDG ' + sdgId + ': ' + error.message);
        }
    };

    const { data: sdgImages } = useQuery({
        queryKey: ['sdgImages', locale],
        queryFn: async () => {
            const images = {};
            for (let i = 1; i <= 17; i++) {
                images[i] = await getImagePath(i, locale);
            }
            return images;
        }
    });

    return { sdgImages };
}

export default useSDGsImages;